var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import get from 'lodash.get';
import isEmpty from 'lodash.isempty';
import { runQuery } from '../utils/query';
import { FactoryComponent } from './FactoryComponent';
export var FactoryContent = function (_a) {
    var config = _a.config, autoIndex = _a.autoIndex, parentDesign = _a.parentDesign, content = _a.content, actions = _a.actions, values = _a.values, watchedValues = _a.watchedValues, props = __rest(_a, ["config", "autoIndex", "parentDesign", "content", "actions", "values", "watchedValues"]);
    var mergedContent = config.content || content;
    var valuesSplitBySource = {
        config: config.values,
        watched: watchedValues,
        props: values,
    };
    if (isEmpty(mergedContent))
        return false;
    var filteredContent = mergedContent.filter(function (_a) {
        var _ = _a[0], __ = _a[1], _b = _a[2], _c = _b === void 0 ? {} : _b, displayQuery = _c.displayQuery;
        var query = get(config, "displayQueries.".concat(displayQuery), displayQuery);
        return runQuery(undefined, query, valuesSplitBySource);
    });
    if (isEmpty(filteredContent))
        return false;
    return (_jsx(_Fragment, { children: filteredContent.map(function (_a, index) {
            var contentComponent = _a[0], contentDesign = _a[1], contentProps = _a[2];
            return (_jsx(FactoryComponent, __assign({ "data-design": contentDesign, component: contentComponent, design: contentDesign, onClick: function () { var _a; return (_a = actions === null || actions === void 0 ? void 0 : actions[contentProps === null || contentProps === void 0 ? void 0 : contentProps.action]) === null || _a === void 0 ? void 0 : _a.call(actions); }, actions: actions, values: values, watchedValues: watchedValues }, props, contentProps), "".concat(parentDesign || '').concat(contentDesign).concat(autoIndex ? index : '')));
        }) }));
};
